import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'sv',
  months: [
    'januari',
    'februari',
    'mars',
    'april',
    'maj',
    'juni',
    'juli',
    'augusti',
    'september',
    'oktober',
    'november',
    'december',
  ],
  monthsShort: ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
  weekdays: ['söndag', 'måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag'],
  weekdaysMin: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
  weekdaysShort: ['sön', 'mån', 'tis', 'ons', 'tor', 'fre', 'lör'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'YYYY-MM-DD',
    LL: '[den] D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': '[den] D MMMM',
    LLL: '[den] D MMMM YYYY HH:mm',
    'LLL-Y': '[den] D MMMM HH:mm',
    LLLL: 'dddd [den] D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd [den] D MMMM HH:mm',
    l: 'YYYY-M-D',
    'l-Y': 'M-D',
    ll: '[den] D MMM YYYY',
    'll-Y': '[den] D MMM',
    lll: '[den] D MMM YYYY HH:mm',
    'lll-Y': '[den] D MMM HH:mm',
    llll: 'ddd[den] D MMM YYYY HH:mm',
    'llll-Y': 'ddd [den] D MMM HH:mm',
    'll-Y+w': 'ddd D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY HH:mm ([GMT]Z)',
  },
  past: {
    y: { one: 'för %s år sen', other: 'för %s år sen' },
    M: { one: 'för %s mån. sen', other: 'för %s mån. sen' },
    w: { one: 'för %s v. sedan', other: 'för %s v. sedan' },
    d: { one: 'för %s d sedan', other: 'för %s d sedan' },
    h: { one: 'för %s tim sedan', other: 'för %s tim sedan' },
    m: { one: 'för %s min sen', other: 'för %s min sen' },
    s: { one: 'för %s s sen', other: 'för %s s sen' },
  },
  future: {
    y: { one: 'om %s år', other: 'om %s år' },
    M: { one: 'om %s mån.', other: 'om %s mån.' },
    w: { one: 'om %s v.', other: 'om %s v.' },
    d: { one: 'om %s d', other: 'om %s d' },
    h: { one: 'om %s tim', other: 'om %s tim' },
    m: { one: 'om %s min', other: 'om %s min' },
    s: { one: 'om %s sek', other: 'om %s sek' },
  },
  abbr: {
    y: { one: '%s år', other: '%s år' },
    M: { one: '%s mån', other: '%s mån' },
    w: { one: '%s v', other: '%s v' },
    d: { one: '%s d', other: '%s d' },
    h: { one: '%s tim', other: '%s tim' },
    m: { one: '%s min', other: '%s min' },
    s: { one: '%s sek', other: '%s sek' },
  },
  justNow: 'just nu',
  yesterday: 'Igår',
  today: 'Idag',
  tomorrow: 'Imorgon',
  weekStart: 1,
};
const localeName: LocaleName = 'sv';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (): string => '',
};
